import { BarLayer, ResponsiveBar } from "@nivo/bar";
import { hexColorRegex } from "../../validations/matchers";
import { BarsChartData } from "./BarsChartFailureCodesInterfaces";
import { HorizontalBarValue } from "components/HorizontalBarValue/HorizontalBarValue.view";
import { truncateLongText } from "utilities/utilities";

export const BarsChartFailureCodes = ({ data }: BarsChartData) => {
    const keys: string[] = [];
    data.forEach((dataItem) => {
        Object.keys(dataItem).forEach((key) => {
            if (key !== "failureCodeName" && key !== "countryCode" && !keys.includes(key) && !key.includes("Color")) {
                keys.push(key);
            }
        });
    });

    const colors: string[] = [];
    data.forEach((dataItem) => {
        return Object.values(dataItem).forEach((value) => {
            if (typeof value === "string" && hexColorRegex.test(value) && !colors.includes(value)) {
                colors.push(value);
            }
        });
    });

    const theme = {
        axis: {
            ticks: {
                text: {
                    fontSize: "13px",
                    fontFamily: "Source Sans 3",
                    fill: "#2B2E3D",
                },
            },
        },
        tooltip: {
            container: {
                display: "none",
            },
        },
    };

    const BarLayers = HorizontalBarValue as unknown as BarLayer<{ [key: string]: string | number }>;

    return (
        <ResponsiveBar
            data={data}
            keys={keys}
            theme={theme}
            layout="horizontal"
            indexBy={"failureCodeName"}
            margin={{ top: 5, right: 60, bottom: 80, left: 200 }}
            padding={0.5}
            valueScale={{ type: "linear" }}
            indexScale={{ type: "band", round: true }}
            colors={colors}
            enableLabel={false}
            enableGridY={false}
            enableGridX={true}
            axisRight={null}
            axisTop={null}
            axisBottom={null}
            axisLeft={{
                tickSize: 0,
                format: (value) => {
                    return truncateLongText(value, 25);
                },
            }}
            label={(d) => `${d.value} min`}
            labelSkipWidth={12}
            labelSkipHeight={12}
            labelTextColor={{
                from: "color",
                modifiers: [["darker", 3]],
            }}
            legends={[]}
            role="application"
            layers={["grid", "axes", "bars", BarLayers, "markers", "legends"]}
        />
    );
};
